import { HardDrives } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Namespace } from '../../../../types/namespace';
import { useSidebarItemDraggable } from '../AgentsSidebar/useSidebarItemDraggable';
import { DraggableItemShell } from '../dnd/DraggableItemShell';
import type { ReservedFolderType } from '../dnd/types';
import { ActionMenu } from './ActionMenu';
import { Item } from './Item';

interface VectorMemoryItemProps {
  namespace: Namespace;
  spaceId?: string | null;
  ancestorReservedType?: ReservedFolderType | null;
  onEdit: (ns: Namespace) => void;
  onDelete: (ns: Namespace) => void;
  isNested?: boolean;
}

const VectorMemoryItemComponent: React.FC<VectorMemoryItemProps> = ({
  namespace,
  spaceId,
  ancestorReservedType = null,
  onEdit,
  onDelete,
  isNested = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const draggable = useSidebarItemDraggable({
    itemId: namespace.id,
    kind: 'vector',
    parentId: namespace.folderId ?? null,
    spaceId: namespace.spaceId ?? spaceId ?? null,
    label: namespace.name,
    ancestorReservedType,
  });

  return (
    <DraggableItemShell
      ref={draggable.setNodeRef}
      isDragging={draggable.isDragging}
      dropAbove={draggable.showDropAbove}
      dropBelow={draggable.showDropBelow}
    >
      <Item
        icon={<HardDrives size={16} />}
        label={namespace.name}
        isNested={isNested}
        isMenuOpen={Boolean(anchorEl)}
        onClick={() => onEdit(namespace)}
        onMenuClick={anchor => {
          setAnchorEl(anchor);
        }}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onEdit={() => {
          setAnchorEl(null);
          onEdit(namespace);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(namespace);
        }}
        showEdit={true}
      />
    </DraggableItemShell>
  );
};

export const VectorMemoryItem = React.memo(VectorMemoryItemComponent);
